/* 本家 KittySpout と同じ、フッターの折りたたみ。
   スマホ（〜768px）＝見出しだけ表示、押すと開く。
   PC（769px〜）＝ぜんぶ開いたまま（本家と同じ）。 */
(function () {
  var MQ = window.matchMedia('(min-width:769px)');

  function setup() {
    var blocks = document.querySelectorAll('.footer .footer-block');
    if (!blocks.length) return;

    Array.prototype.forEach.call(blocks, function (b) {
      var head = b.querySelector('.footer-block__heading');
      var body = b.querySelector('.footer-block__details-content');
      if (!head || !body) return;

      if (!head.dataset.ksReady) {
        head.dataset.ksReady = '1';
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');
        head.classList.add('ks-fold-head');
        head.addEventListener('click', function () {
          if (MQ.matches) return;              // PCでは開閉せん
          b.classList.toggle('ks-open');
        });
        head.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); head.click(); }
        });
      }
      // PCでは常に開く、スマホでは閉じた状態から
      if (MQ.matches) b.classList.add('ks-open');
      else b.classList.remove('ks-open');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  MQ.addEventListener ? MQ.addEventListener('change', setup) : MQ.addListener(setup);
})();

/* ===== 2026-09-01 カウントダウンを実際に動かす =====
   本家は毎日リセットの24時間タイマー。日付が変わるまでの残りを1秒ごとに描く。
   .cd の中の <b> を [日, 時, 分, 秒] の順で埋める。 */
(function () {
  function pad(n){ return String(n).padStart(2,'0'); }
  function tick() {
    var rails = document.querySelectorAll('.fp .cd');
    if (!rails.length) return;
    var now = new Date();
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0); // 今日の終わり
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    var v = [pad(d), pad(h), pad(m), pad(s)];
    rails.forEach(function (r) {
      var bs = r.querySelectorAll('b');
      for (var i = 0; i < bs.length && i < 4; i++) {
        if (bs[i].textContent !== v[i]) bs[i].textContent = v[i];
      }
    });
  }
  function start(){ tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ===== 2026-09-01 横スクロールの端のフェード =====
   中身がはみ出しとる時だけ、スクロール位置に応じて左右の端を薄くする。
   「見た目だけ」やのうて、実際にスクロールできる状態と連動させる。 */
(function () {
  var SEL = '.fp .rail, .fp .ugc, .fp .thumbs, .fp .heroTrack, .fp .trust, .fp .grid4';
  function upd(el) {
    var max = el.scrollWidth - el.clientWidth;
    if (max <= 4) { el.removeAttribute('data-fade'); return; }
    var l = el.scrollLeft > 4, r = el.scrollLeft < max - 4;
    el.setAttribute('data-fade', l && r ? 'both' : (l ? 'left' : (r ? 'right' : 'none')));
  }
  function setup() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.__fadeBound) { upd(el); return; }
      el.__fadeBound = true;
      el.addEventListener('scroll', function () { upd(el); }, { passive: true });
      upd(el);
    });
  }
  function boot(){ setup(); setTimeout(setup, 800); setTimeout(setup, 2500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('resize', setup, { passive: true });
  window.addEventListener('load', setup);
})();
